/**
 * True when a fetch error is a *candidate* for Better Auth session expiration (TK-9807): a 401
 * from this app's own relative `/api/...` routes.
 *
 * **This is a cheap pre-filter, not a verdict.** A 401 on our own API does not prove the session
 * died — our routes also return 401 for reasons that have nothing to do with the caller's session:
 * an ownership/IDOR guard, checkout controllers rejecting a guest with no `profile_id`, a valid
 * session whose `profile` row is missing, and (via `finalize-cart`) an upstream ACCS status
 * forwarded verbatim. None of these carry a distinguishing marker — `requireProfileFromSession`
 * throws a bare `{ statusCode: 401, statusMessage: 'Unauthorized' }`, identical on the wire to the
 * rest. Acting on this signal alone would sign out users whose session is perfectly healthy.
 *
 * So callers MUST confirm the session is actually gone before acting on it — see
 * `handleSessionExpired`, which asks Better Auth directly.
 *
 * Absolute URLs are excluded outright: `useApiFetch` also fronts legacy Magento REST calls (a
 * separate auth system) that legitimately 401 on a bad password, and those are never worth even
 * checking.
 */
export function isSessionExpiryCandidate(status: number, requestUrl: string): boolean {
    return status === 401 && !/^https?:\/\//i.test(requestUrl)
}
